import React, {
	useEffect, useState
}from "react"
import {
	Form, Select
}from "antd"
import {
	useDispatch, useSelector
}from "react-redux"
import i18n from "./localization"
import {
	reResponsibilityTypeActions
}from '../../nsi/ReResponsibilityTypes/actions'
import "./style.css"
import CustomButton from "../../../components/ButtonCustom"
import {
	CustomSelect
}from "../../../components/CustomSelect"
import {
	useDebounce
}from "use-lodash-debounce"
import {
	appealsActions
}from "../../Appeals/store/actions"

const CreateDisciplinaryActionModal = ({ createDisciplinaryAction, loading }) => {
	const [form] = Form.useForm()
	const [regNumber, setRegNumber] = useState("")
	const searchRegNumber = useDebounce(regNumber, 750)
	const pageSize = 10
	const dispatch = useDispatch()
	const isRu = useSelector((state) => state.globalReducer.isRu)
	const types = useSelector(state => state.reResponsibilityTypeReducer.list)
	const appeals = useSelector((state) => state.appealsReducer.listPrevAppealsForDisciplinaryActions)

	useEffect(() => {
		dispatch(reResponsibilityTypeActions.getList())
		return () => {
			dispatch(reResponsibilityTypeActions.clearResponsibilityType())
		}
	}, [])

	useEffect(() => {
		if (searchRegNumber && searchRegNumber.trim().length > 2){
			dispatch(appealsActions.getListPrevAppealsForDisciplinaryActions({
				pageSize  : pageSize,
				regNumber : searchRegNumber
			}))
		}
	}, [searchRegNumber])

	function changeAppeal(reOrgAppealId){
		const selected = appeals?.find((appeal) => {
			return appeal.reOrgAppealId == reOrgAppealId
		})
		form.setFieldsValue({
			AppealId: selected?.appealId
		})
	}

	return (
		<Form
			form={ form }
			labelAlign="left"
			labelCol={ { span: 5 } }
			layout="horizontal"
			name="form-responsibility"
			onFinish={ (values) => createDisciplinaryAction(values) }
		>
			<Form.Item
				className="responsibilityType"
				label={ i18n.labelResponsibilityType[isRu] }
				name="ResponsibilityTypeId"
				rules={ [
					{
						message  : i18n.isRequired[isRu],
						required : true
					}
				] }
			>
				<CustomSelect
					allowClear
					showSearch
					notFoundContent={ null }
					optionFilterProp="title"
					placeholder={ i18n.placeholderResponsibilityType[isRu] }
				>
					{ types?.map((value) => {
						return (
							<Select.Option
								key={ value.id }
								title={ isRu ? value.name : value.nameBel }
								value={ value.id }
							>
								{ isRu ? value.name : value.nameBel }
							</Select.Option>
						)
					}) }
				</CustomSelect>
			</Form.Item>
			<Form.Item
				noStyle
				shouldUpdate
			>
				{ () => {
					return (
						<Form.Item
							className="appeal"
							label={ i18n.labelAppeal[isRu] }
							name="ReOrgAppealId"
							validateStatus={ form.getFieldValue("ReOrgAppealId") ? null : "warning" }
						>
							<CustomSelect
								allowClear
								showSearch
								filterOption={ false }
								notFoundContent={ null }
								placeholder={ i18n.placeholderAppeal[isRu] }
								onChange={ changeAppeal }
								onSearch={ (value) => setRegNumber(value) }
							>
								{ appeals?.map((value) => {
									return (
										<Select.Option
											key={ value.reOrgAppealId }
											title={ value.regNumber }
											value={ value.reOrgAppealId }
										>
											{ value.regNumber }
										</Select.Option>
									)
								}) }
							</CustomSelect>
						</Form.Item>
					)
				} }
			</Form.Item>
			<Form.Item
				hidden
				noStyle
				name="AppealId"
			/>
			<Form.Item className="save">
				<CustomButton
					htmlType="submit"
					loading={ loading }
					type="orange"
				>
					{ i18n.createCreateDisciplinaryAction[isRu] }
				</CustomButton>
			</Form.Item>
		</Form>
	)
}

export default CreateDisciplinaryActionModal
